module.exports = __webpack_public_path__ + "static/media/fire-detection.83198472.jpg";